import { TransportOptionsAdministrationModule } from './../../administration/transport-options-administration/transport-options-administration.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportRegistrationOptionsComponent } from './component/transport-registration-options.component';
import { TransportOptionsPanelModule } from '../../../components/transport-options-panel/transport-options-panel.module';
import { CommonLayoutModule, TranslationComponentsModule } from '@sdbn/common';
import { AppClientResourcesModule } from '@sdbn/common';



@NgModule({
  declarations: [
    TransportRegistrationOptionsComponent,
  ],
  imports: [
    CommonModule,
    TransportOptionsPanelModule,
    CommonLayoutModule,
    AppClientResourcesModule,
    TranslationComponentsModule
  ]
})
export class TransportRegistrationOptionsModule { }
